import axios from "axios";
import { Message, MessageBox } from "element-ui"; //element-ui提示信息的组件
import store from "@/store";
// import qs from "qs";

// 创建axios实例
const service = axios.create({
    baseURL: process.env.VUE_APP_API, // 此处的baseURL 可在config文件夹的两个env文件修改 尽量做到一键部署
    timeout: 10000, // 请求超时时间
    withCredentials: true,
    // transformRequest: [
    //     function(data) {
    //         data = qs.stringify(data);
    //         return data;
    //     }
    // ],
    headers: {
        // "Content-Type": "application/x-www-form-urlencoded"
        "Content-Type": "application/json; charset=utf-8"
    }
});

// request拦截器
service.interceptors.request.use(
    config => {
        if (store.getters.token) {
            // config.headers["Authorization"] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
            // config.headers.common["Authorization"] =
            //     store.getters.token || sessionStorage.getItem("token");
            //让每个请求携带自定义token 请根据实际情况自行修改
        }
        return config;
    },
    error => {
        // Do something with request error
        console.log(error); // for debug
        Promise.reject(error);
    }
);

// response 拦截器
service.interceptors.response.use(
    response => {
        // debugger;
        // alert('status'+response.status)
        if (response.status === 200) {
            //dataAxios 是 axios 返回数据中的 data
            // const dataAxios = response.data;
            //  重定向后的最终地址，以此判断cas是否登录
            //alert('dataAxios'+JSON.stringify(dataAxios))
            // const responseURL = response.request.responseURL;
            // if (
            //     responseURL &&
            //     responseURL.indexOf("https://passport") !== -1 &&
            //     typeof dataAxios === "string" &&
            //     dataAxios.indexOf("<!DOCTYPE html>") !== -1 &&
            //     responseURL.indexOf("%2FchannelCustomer%2FuserInfo%2F") !== -1
            // ) {
            //     // 重定向cas登录页面
            //     // 判断是否在iframe里面  https://www.yimidida.com/
            //     +// alert(JSON.stringify(response) +'response')
            //     console.log(responseURL);
            //     if (window.top === window.self) {
            //         const isIE =
            //             !!window.ActiveXObject || "ActiveXObject" in window;
            //         if (isIE) {
            //             window.location.href =
            //                 process.env.VUE_APP_CAS +
            //                 "?service=" +
            //                 window.location.href.replace("#", "%23");
            //         } else {
            //             window.location.href =
            //                 process.env.VUE_APP_CAS +
            //                 "?service=" +
            //                 window.location.href.replace("#", "%23");
            //         }
            //     } else {
            //         window.top.location.href =
            //             process.env.VUE_APP_CAS +
            //             "?service=" +
            //             window.top.location.href.replace("#", "%23");
            //     }
            //     const err = new Error("未授权，请登录"); // catch接口;
            //     throw err;
            // }
            if (!response.data.success) {
                if (
                    response.data.errorCode === "403" ||
                    response.data.errorCode === "401"
                ) {
                    MessageBox.confirm(response.data.errorMsg, {
                        confirmButtonText: "重新登录",
                        cancelButtonText: "取消",
                        type: "warning"
                    })
                        .then(() => {
                            store.dispatch("FedLogOut").then(() => {
                                // location.reload(); // 为了重新实例化vue-router对象 避免bug
                            });
                        })
                        .catch(() => {});
                    return Promise.reject("error");
                }
                if (
                    response.data.errorCode === "504" ||
                    response.data.errorCode === "404"
                ) {
                    Message.error({ message: "服务器被吃了⊙﹏⊙∥" });
                } else if (response.data.errorCode === "400") {
                    Message.error({ message: response.data.errorMsg });
                } else if (response.data.errorCode === "500") {
                    Message.error({ message: response.data.errorMsg });
                }
            }
            return response.data;
        }
    },
    error => {
        // console.log(response);
        //判断异常
        if (error && error.response) {
            console.log(error.response);
            console.log("err" + error); // for debug
            if (
                error.response.status === 403 ||
                error.response.status === 401
            ) {
                store.dispatch("FedLogOut").then(() => {
                    // location.reload(); // 为了重新实例化vue-router对象 避免bug
                });
            }
        }
        if (error.message == "Network Error") {
            console.log(error.message);
        } else {
            Message({
                message: error.message,
                type: "error"
            });
        }
        return Promise.reject(error);
    }
    // 以上error开发的时候具体业务具体处理↑
);

export default service;
